import * as React from 'react';
import { useState, FC } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Hall } from '../../../common/interfaces/hall';
import { createToastNotification } from '../../../utilities/helpers';
import { insertHall, updateHall } from '../../../api/hall';

export const HallModal: FC<{
  modalName: string;
  opened: boolean;
  handleClose: (refresh?: boolean) => void;
  hall: Hall | null;
}> = ({ modalName, hall, opened, handleClose }) => {
  const [name, setName] = useState(hall?.name ?? '');
  const [description, setDescription] = useState(hall?.description ?? '');

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = { id: hall?.id, name, description };

    if (!name.trim()) {
      createToastNotification('info', 'Popunite naziv hale');
      return;
    }

    try {
      if (formData.id) {
        await updateHall(formData as Hall);
      } else {
        await insertHall(formData as Hall);
      }
      createToastNotification('success', 'Hala je uspešno sačuvana');
      handleClose(true);
    } catch (error: any) {
      createToastNotification('error', error.response?.data?.message);
    }
  };

  React.useEffect(() => {
    setName(hall?.name ?? '');
    setDescription(hall?.description ?? '');
  }, [hall, opened]);

  return (
    <Dialog
      open={opened}
      onClose={() => {
        handleClose();
      }}
      PaperProps={{
        component: 'form',
        onSubmit: handleSubmit,
      }}
    >
      <DialogTitle>{modalName}</DialogTitle>
      <DialogContent>
        <input type="hidden" name="id" value={hall?.id} />
        <TextField
          autoFocus
          margin="dense"
          id="name"
          name="name"
          label="Naziv hale *"
          type="text"
          sx={{ width: '550px' }}
          variant="filled"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          margin="dense"
          id="description"
          name="description"
          label="Opis hale"
          type="text"
          sx={{ width: '550px' }}
          variant="filled"
          multiline
          rows={4}
          maxRows={8}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose()}>Otkaži</Button>
        <Button type="submit">Sačuvaj</Button>
      </DialogActions>
    </Dialog>
  );
};
